import { Component } from '@angular/core';
import { ModalService } from '../../../../../../../components/modal-list/modal-list.service';
import { I18nModule } from '@spartacus/core';

@Component({
  selector: 'close-confirmation',
  standalone: true,
  imports: [I18nModule],
  templateUrl: './close-confirmation.component.html',
  styleUrl: './close-confirmation.component.scss',
})
export class CloseConfirmationComponent {
  constructor(private modalService: ModalService) {}

  cancel() {
    this.modalService.close();
  }

  confirm() {
    this.modalService.close(['modal-1', 'modal-1-close-confirmation']);
  }
}
